import {NgModule} from '@angular/core';
import {LayoutComponent} from '../admin/layout.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CompanySearchComponent} from './company-search/company-search.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataListOverviewComponent} from './data-list-overview/data-list-overview.component';
import {HighchartsChartModule} from 'highcharts-angular';
import {ChartComponent} from './chart/chart.component';
import {PipesModule} from './pipes/pipes.module';
import {FileUploadComponent} from '../file-upload/file-upload.component';
import {ImageUploadComponent} from '../image-upload/image-upload.component';
import {ImageCropperModule} from 'ngx-image-cropper';
import {ProgressBarComponent} from './progress-bar/progress-bar.component';
import {PhotoUploaderComponent} from '../photo-uploader/photo-uploader.component';
import {TargetAudienceComponent} from './target-audience/target-audience.component';
import {InputsModule} from './inputs/inputs.module';
import {DatetimePickerV2Component} from './datetime-picker-v2/datetime-picker-v2.component';
import {DateRangePickerV2Component} from './date-range-picker-v2/date-range-picker-v2.component';
import {PageSelectionComponent} from './page-selection/page-selection.component';
import {MultiSelectDropdownComponent} from './multiselect-dropdown/multiselect-dropdown.component';
import {ImageUploadPreviewComponent} from './ui/components/image-upload-preview/image-upload-preview.component';
import {FileUploadDragDropComponent} from './ui/components/file-upload-drag-drop/file-upload-drag-drop.component';
import {DirectivesModule} from './directives/directives.module';
import {DialogConfirmComponent} from './ui/components/dialogs/dialog-confirm/dialog-confirm.component';
import {DialogLayoutInnerXComponent} from './ui/components/dialogs/dialog-layout-inner-x/dialog-layout-inner-x.component';
import {InlineSVGModule} from 'ng-inline-svg-2';
import {UploadProgressBarComponent} from './upload-progress-bar/upload-progress-bar.component';
import {GenericTableComponent} from './ui/components/generic-table/generic-table.component';
import {ReadMoreTxtComponent} from './ui/components/read-more-txt/read-more-txt.component';
import {PhotoCropComponent} from './ui/components/photo-crop/photo-crop.component';
import {ModalComponent} from './modal/modal.component';
import {AddCompanyComponent} from './ui/components/add-company/add-company.component';
import {WeekDayTimeSelectionComponent} from './ui/components/week-day-time-selection/week-day-time-selection.component';
import {ToggleInputComponent} from './ui/components/toggle-input/toggle-input.component';
import {ArtistsSimpleSearchComponent} from './ui/components/artists-simple-search/artists-simple-search.component';
import {MultiSelectChipsSearchComponent} from './ui/components/multi-select-chips-search/multi-select-chips-search.component';
import {SharedUiMaterialModule} from './ui/modules/shared-ui-material/shared-ui-material.module';

import {InsertEmojiComponent} from './ui/components/app-insert-emoji/insert-emoji.component';
import {ImageUploadPopupComponent} from './ui/components/image-upload-popup/image-upload-popup.component';
import {SetAnchorsOnImageComponent} from './ui/components/set-anchors-on-image/set-anchors-on-image.component';
import {TimeSelectorComponent} from './time-selector/time-selector.component';
import {CreateProductsComponent} from './ui/components/create-products/create-products.component';
import {EventSelectionComponent} from './ui/components/event-selection/event-selection.component';
import {ImageUploadCropComponent} from './ui/components/image-upload-crop/image-upload-crop.component';
import {FileInputCropComponent} from './ui/components/file-input-crop/file-input-crop.component';
import {TargetAudienceService} from './target-audience/target-audience.service';
import {NotificationsSharedComponent} from './components/notifications/notifications.component';
import {NotificationsV2SharedComponent} from './components/notifications-v2/notifications.component';
import {IconSelectionComponent} from './components/custom-tabs-icons-selection/custom-tabs-icons-selection.component';
import {CustomEndpointSearchComponent} from './ui/components/custom-endpoint-search/custom-endpoint-search.component';
import {DaysTimeSelectionComponent} from './components/days-time-selection/days-time-selection.component';
import {ArtistsSearchComponent} from './components/artists-search/artists-search.component';
import {TranslateModule} from '@ngx-translate/core';
import {HorizontalMenuComponent} from './components/horizontal-menu/horizontal-menu.component';
import {AlertModule} from './alert/alert.module';
import {DynamicFieldsComponent} from './components/dynamic-fields/dynamic-fields.component';
import {UsersSearchComponent} from './ui/components/users-search/users-search.component';
import {SelectDropDownModule} from './select-dropdown';
import {TimezoneSelectComponent} from './ui/components/timezone-select/timezone-select.component';
import {ProductSelectComponent} from './product-select/product-select.component';
import {UiFormsModule} from '../ui-components/ui-forms/ui-forms.module';

@NgModule({
  declarations: [
    ProductSelectComponent,
    LayoutComponent,
    CompanySearchComponent,
    DataListOverviewComponent,
    ChartComponent,
    FileUploadComponent,
    ImageUploadComponent,
    ProgressBarComponent,
    PhotoUploaderComponent,
    TargetAudienceComponent,
    DatetimePickerV2Component,
    DateRangePickerV2Component,
    PageSelectionComponent,
    MultiSelectDropdownComponent,
    ImageUploadPreviewComponent,
    FileUploadDragDropComponent,
    DialogConfirmComponent,
    DialogLayoutInnerXComponent,
    UploadProgressBarComponent,
    GenericTableComponent,
    ReadMoreTxtComponent,
    PhotoCropComponent,
    ReadMoreTxtComponent,
    ModalComponent,
    AddCompanyComponent,
    WeekDayTimeSelectionComponent,
    ToggleInputComponent,
    ArtistsSimpleSearchComponent,
    MultiSelectChipsSearchComponent,
    ImageUploadPopupComponent,
    SetAnchorsOnImageComponent,
    TimeSelectorComponent,
    InsertEmojiComponent,
    CustomEndpointSearchComponent,
    ImageUploadCropComponent,
    FileInputCropComponent,
    CreateProductsComponent,
    EventSelectionComponent,
    NotificationsSharedComponent,
    NotificationsV2SharedComponent,
    IconSelectionComponent,
    DaysTimeSelectionComponent,
    ArtistsSearchComponent,
    HorizontalMenuComponent,
    DynamicFieldsComponent,
    UsersSearchComponent,
    TimezoneSelectComponent,
  ],
  imports: [
    ImageCropperModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    HighchartsChartModule,
    PipesModule,
    InputsModule,
    DirectivesModule,
    SharedUiMaterialModule,
    InlineSVGModule.forRoot({baseUrl: '/assets'}),
    AlertModule,
    TranslateModule,
    SelectDropDownModule,
    UiFormsModule,
  ],
  exports: [
    ProductSelectComponent,
    CompanySearchComponent,
    DataListOverviewComponent,
    ChartComponent,
    FileUploadComponent,
    ImageUploadComponent,
    ProgressBarComponent,
    PhotoUploaderComponent,
    TargetAudienceComponent,
    DatetimePickerV2Component,
    DateRangePickerV2Component,
    PageSelectionComponent,
    MultiSelectDropdownComponent,
    ImageUploadPreviewComponent,
    FileUploadDragDropComponent,
    DialogConfirmComponent,
    DialogLayoutInnerXComponent,
    UploadProgressBarComponent,
    GenericTableComponent,
    ReadMoreTxtComponent,
    PhotoCropComponent,
    ReactiveFormsModule,
    ModalComponent,
    SharedUiMaterialModule,
    MultiSelectChipsSearchComponent,
    DirectivesModule,
    ReactiveFormsModule,
    SharedUiMaterialModule,
    ModalComponent,
    MultiSelectChipsSearchComponent,
    SharedUiMaterialModule,
    ModalComponent,
    AddCompanyComponent,
    InputsModule,
    WeekDayTimeSelectionComponent,
    ToggleInputComponent,
    ArtistsSimpleSearchComponent,
    MultiSelectChipsSearchComponent,
    ImageUploadPopupComponent,
    SetAnchorsOnImageComponent,
    TimeSelectorComponent,
    InsertEmojiComponent,
    CreateProductsComponent,
    EventSelectionComponent,
    InputsModule,
    CustomEndpointSearchComponent,
    ImageUploadCropComponent,
    FileInputCropComponent,
    NotificationsSharedComponent,
    NotificationsV2SharedComponent,
    IconSelectionComponent,
    ArtistsSearchComponent,
    DaysTimeSelectionComponent,
    HorizontalMenuComponent,
    DynamicFieldsComponent,
    UsersSearchComponent,
    FormsModule,
    TimezoneSelectComponent,
  ],
  providers: [TargetAudienceService],
})
export class SharedModule {}
